import * as React from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'

export interface DropdownItem {
    readonly label: string
    readonly value: string
}

interface DropdownSelectFieldProps {
    readonly setValue: (value: DropdownItem) => void,
    readonly label: string
    readonly value: DropdownItem
    readonly items: DropdownItem[]
    readonly id: string,
    disabled: boolean
}

const DropdownSelectField = (props: DropdownSelectFieldProps) => {
    const handleChange = (event: SelectChangeEvent) => {
        const item = props.items.find((item) => item.value == event.target.value)

        if (item != undefined) {
            props.setValue(item)
        }
    }

    return (
        <FormControl size="small" className='MuiTextField-root'>
            <InputLabel>{props.label}</InputLabel>
            <Select
                disabled={props.disabled}
                id={props.id}
                value={props.value.value}
                label={props.id}
                onChange={handleChange}
            >
                {props.items.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)}
            </Select>
        </FormControl>
    )
}

export default DropdownSelectField